import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';

// Data table
import { Skeletonitems, SkeletonbodyTemplate } from '../../../../appconfig/Settings';

import { MasterTab } from '../../MasterTab';
import { getAllDetails, getAllDetailsDirect, postAllData } from '../../../../service/ProductService';
import { APPLICATIONS, DOCUMENT_MASTER, DOCUMENTS, EDIT_MAP_DOCUMENTS } from '../../../../config/ApiConstant';
import { DocumentMasterListColumns } from '../../../../appconfig/DatatableSetting';
import { Badge } from 'primereact/badge';
import { AddUpdateAppDocValidate } from '../../../../config/Validate';
import { Toolbar } from 'primereact/toolbar';
import { useNavigate } from 'react-router-dom';

export const DocumentMaster = () => {
    document.title = 'Document Master | GSPC';

    const navigate = useNavigate();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applications, setApplications] = useState<any>([]);
    const [documentsList, setDocumentsList] = useState<any>([]);
    const [documentMasterList, setDocumentMasterList] = useState<any>([]);
    const [documentMasterData, setDocumentMasterData] = useState<any>({
        required_doc: 0
    });
    const [documentMasterAllData, setDocumentMasterAllData] = useState<any>({});
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [requiredDocId, setRequiredDocId] = useState<any>(null);

    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        getAllApplications();
        getAllDocumentList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get all applications
    const getAllApplications = async () => {
        try {
            const response = await getAllDetailsDirect(APPLICATIONS);
            if (response) {
                let appOption: any = [];
                response.map((option: any) => {
                    const row = {
                        name: option.AppName,
                        code: option.AppName
                    };
                    appOption.push(row);
                });
                setApplications(appOption);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all documents list
    const getAllDocumentList = async () => {
        try {
            const response = await getAllDetailsDirect(DOCUMENTS + '?type=all');
            if (response) {
                let docOption: any = [];
                response.map((option: any) => {
                    const row = {
                        name: option.DocName,
                        code: option.SrNo
                    };
                    docOption.push(row);
                });
                setDocumentsList(docOption);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setDocumentMasterData({});
        setDocumentMasterAllData({});
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'appName' || name === 'docName') {
            if (name === 'appName') {
                getDocumentMasterData(e.code);
            }
            val = e;
        } else if (name === 'required_doc') {
            val = e.checked === true ? 1 : 0;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setDocumentMasterData({ ...documentMasterData, [name]: val });
    };

    // Get document master data
    const getDocumentMasterData = async (appName: any) => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(DOCUMENT_MASTER + '?appname=' + appName);
            if (response) {
                if (!window.cn(response)) {
                    let documentList = response.documentList.split(',');
                    documentList = documentList.reverse();
                    let responseString = documentList.slice(0, -1);

                    let documentId = response.DocSrNoSeq.split(',');
                    documentId = documentId.reverse();

                    const mergedArr = documentId.map((item: any, index: any) => ({
                        docId: item,
                        docName: responseString[index]
                    }));

                    setDocumentMasterAllData(response);
                    setDocumentMasterList(mergedArr);
                } else {
                    setDocumentMasterList([]);
                }
                setPageLoad(true);
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Template for document name
    const documentNameTemplate = (rowData: any) => {
        return <>{rowData}</>;
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        let { requiredDocName } = documentMasterAllData;

        let requiredDoc = !window.cn(requiredDocName) && requiredDocName.split(',');

        return <div className="actions">{requiredDoc.length > 0 ? requiredDoc.includes(rowData?.docName) ? <Badge severity="success" value="Required" /> : <Badge severity="warning" value="Not Required" /> : ''}</div>;
    };

    // Template for action
    const actionTemplate = (rowData: any) => {
        let { requiredDocName, DocSrNoSeq } = documentMasterAllData;
        let docNo = DocSrNoSeq.split(',');
        docNo = docNo.reverse();

        let requiredDoc = !window.cn(requiredDocName) ? requiredDocName.split(',') : [];
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="Edit" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" onClick={() => onEditAppDoc(rowData?.docId, requiredDoc.includes(rowData?.docName))} />
                </div>
            </>
        );
    };

    // On edit application document
    const onEditAppDoc = (AppSrNo: any, requiredId: any) => {
        setRequiredDocId(AppSrNo);
        let requiredDoc = requiredId === true ? 1 : 0;

        let addedDoc;
        if (!window.cn(documentsList)) {
            addedDoc = documentsList.find((item: any) => item.code === Number(AppSrNo));
        }

        setDocumentMasterData({
            ...documentMasterData,
            required_doc: requiredDoc,
            docName: addedDoc
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Add application document
    const addUpdateApplicationDocument = async () => {
        try {
            const { errors, isError } = AddUpdateAppDocValidate(documentMasterData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                const requestData = {
                    AppName: documentMasterData?.appName?.name,
                    DocSrNoSeq: documentMasterData?.docName?.code,
                    required_doc: documentMasterData?.required_doc
                };

                const response = await postAllData(EDIT_MAP_DOCUMENTS, requestData);
                if (response) {
                    getDocumentMasterData(documentMasterData.appName.code);
                    setSubmitLoading(false);
                    setDocumentMasterData({ docName: '', appName: documentMasterData?.appName });
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                }
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Add New Document" icon="pi pi-plus" className="p-button" onClick={() => navigate('/app/add-document')} />
            </>
        );
    };

    return (
        <>
            <MasterTab mainTabLabel="Document Master" />
            <Toast ref={toast} />
            <div className="card mt-4">
                <div className="p-fluid formgrid grid align-items-center">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="appName">
                            Application Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={documentMasterData?.appName}
                                name="appName"
                                options={applications}
                                filter
                                optionLabel="name"
                                placeholder="Select Application"
                                onChange={(e) => onInputChange(e.value, 'appName')}
                                className={errors['appName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['appName']}</small>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="docName">
                            Document Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={documentMasterData?.docName}
                                name="docName"
                                options={documentsList}
                                filter
                                optionLabel="name"
                                placeholder="Select Application"
                                onChange={(e) => onInputChange(e.value, 'docName')}
                                className={errors['docName'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['docName']}</small>
                    </div>
                    <div className="field col-12 md:col-4 align-items-center flex mb-0">
                        <Checkbox inputId="Required" name="Required" value="Required" checked={documentMasterData?.required_doc === 1 ? true : false} onChange={(e) => onInputChange(e, 'required_doc')} className="ml-2" />
                        <label htmlFor="PracTrainingQual " className="ml-2 mb-0">
                            {' '}
                            Required
                        </label>
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button label="Clear" icon="pi pi-times" onClick={() => clearAll()} className="p-button-secondary mr-2" />
                            <Button label="ADD" icon="pi pi-check" onClick={() => addUpdateApplicationDocument()} loading={submitLoading} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <Toolbar right={rightToolbarTemplate}></Toolbar>
                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable
                            value={documentMasterList}
                            showGridlines
                            stripedRows
                            globalFilter={globalFilter}
                            filters={globalFieldFilter}
                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                            className="datatable-responsive"
                            emptyMessage="No Data Found"
                        >
                            {DocumentMasterListColumns.map((col, i) => {
                                if (col.field === 'action') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                } else if (col.field === 'docName') {
                                    return (
                                        <Column
                                            key={col.field}
                                            field={col.field}
                                            header={col.header}
                                            //  body={documentNameTemplate}
                                        />
                                    );
                                } else if (col.field === 'status') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} style={{ minWidth: '10rem' }} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems}>
                            {DocumentMasterListColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}
            </div>
        </>
    );
};
